import { functions } from "@/plugins/firebase";
import { AbstractAdapter } from "@/adapter/abstractAdapter";
import {
  setCastApi,
  getCastDetailInfoApi,
  setBankAccountApi,
  getBankAccountApi,
  getPaymentInfoApi,
} from "@/helper/functions";
import { ICast } from "@/types/cast";
import { bankAccount } from "@/types/abstract";
import { httpsCallable } from "firebase/functions";

export class CastApi extends AbstractAdapter {
  async getUserInfo(isLoading = true, uid?: string): Promise<any> {
    if (isLoading) {
      this.startLoading();
    }
    const getCastDetailInfoFunc = httpsCallable(
      functions,
      getCastDetailInfoApi
    );
    try {
      return await getCastDetailInfoFunc({ uid: uid }).then((res) => {
        return res;
      });
    } finally {
      if (isLoading) {
        this.finishLoading();
      }
    }
  }

  async setCastData(castData: Partial<ICast>): Promise<void> {
    this.startLoading();

    // 登録している書籍の詳細情報取得
    const setCastFunc = httpsCallable(functions, setCastApi);
    try {
      await setCastFunc({ castData: castData });
    } finally {
      this.finishLoading();
    }
  }

  async getBankAccount(): Promise<any> {
    this.startLoading();

    const getBankAccountFunc = httpsCallable(functions, getBankAccountApi);
    try {
      return await getBankAccountFunc({});
    } finally {
      this.finishLoading();
    }
  }

  async getPaymentInfo(): Promise<any> {
    this.startLoading();

    const getPaymentInfoFunc = httpsCallable(functions, getPaymentInfoApi);
    try {
      return await getPaymentInfoFunc({});
    } finally {
      this.finishLoading();
    }
  }

  async setBankAccount(bankAccount: bankAccount): Promise<void> {
    this.startLoading();

    const setBankAccountFunc = httpsCallable(functions, setBankAccountApi);
    try {
      await setBankAccountFunc({ bankAccount: bankAccount });
    } finally {
      this.finishLoading();
    }
  }
}
